import './VisionStyles.css'
import React from 'react'

const Vision = () => {
  return (
    <div className='section-3'>
        <div className='vision'>
            <h2>Vision</h2>
            <p>Lorem ipsum dolor sit amet. Sed impedit quaerat id velit explicabo ut praesentium quidem 33 consequatur vero et maiores distinctio est numquam dolorem et quia voluptatum.</p>
        </div>
        <div className='mission'>
            <h2>Mission</h2>
            <p>Lorem ipsum dolor sit amet. Sed impedit quaerat id velit explicabo ut praesentium quidem 33 consequatur vero et maiores distinctio est numquam dolorem et quia voluptatum.</p>
        </div>
    </div>
  )
}

export default Vision
